import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

export const TheSupportersTitle: React.FC<EmptyObject> = () => {
	return (
		<Text
			as="h1"
			fontWeight="bold"
			size="large"
			variant="heading"
			className="mb-12"
			data-testid="petition-page-supporters-title"
		>
			<Translate value="corgi.petition_actions.supporter_voices_text_list.heading" />
		</Text>
	);
};
